module.exports = __webpack_public_path__ + "img/SK.f6de0159.png";